import React, { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { Button } from "../../components/ui/button";
import { Label } from "../../components/ui/label";
import { Textarea } from "../../components/ui/textarea";
import { toast } from "sonner";

export function SupportTab({ support, reload }) {
  const [f, setF] = useState(support);
  useEffect(() => setF(support), [support]);
  const save = async () => {
    try { await api.patch("/support/info", f); toast.success("Saved"); reload(); }
    catch { toast.error("Failed"); }
  };
  return (
    <div className="bg-white border border-[#E5E0D8] rounded-2xl p-8 max-w-3xl space-y-5" data-testid="support-form">
      <div><Label className="text-xs uppercase tracking-widest text-[#4A5C50]">Support email</Label>
        <input type="email" className="underline-input mono" value={f.email || ""} onChange={(e) => setF({ ...f, email: e.target.value })} data-testid="support-email-input" /></div>
      <div><Label className="text-xs uppercase tracking-widest text-[#4A5C50]">Support phone</Label>
        <input className="underline-input mono" value={f.phone || ""} onChange={(e) => setF({ ...f, phone: e.target.value })} data-testid="support-phone-input" /></div>
      <div><Label className="text-xs uppercase tracking-widest text-[#4A5C50]">Hours</Label>
        <input className="underline-input" value={f.hours || ""} onChange={(e) => setF({ ...f, hours: e.target.value })} /></div>
      <div><Label className="text-xs uppercase tracking-widest text-[#4A5C50]">Refund notice</Label>
        <Textarea rows={5} value={f.refund_notice || ""} onChange={(e) => setF({ ...f, refund_notice: e.target.value })} className="mt-2 rounded-xl border-[#E5E0D8]" data-testid="support-refund-input" /></div>
      <Button onClick={save} className="rounded-xl bg-[#184A30] text-white" data-testid="support-save-btn">Save</Button>
    </div>
  );
}
